import { useModalSlot } from 'vue-final-modal'
import ModalContentResetCart from '~/components/Modal/Content/ModalContentResetCart.vue'
import ModalContentResetCartBottom from '~/components/Modal/Content/ModalContentResetCartBottom.vue'
import { messagesModal } from '~/composables/messagesModal'
import { cart } from '~/store/cart'
import { checkout } from '~/store/checkout'
import { DispatchTypeOrderBuddy } from '~/types/orderbuddy-types'
import { isAccountPath, isCheckoutPath, isDeliveryPath } from '~/utils/path-utils'
let dispatchModalIsOpen = false
export function getTargetDispatchType (path: string) {
    return isDeliveryPath(path) ? DispatchTypeOrderBuddy.DELIVER : DispatchTypeOrderBuddy.PICK_UP
}

export function shouldResetCart (dispatchType: DispatchTypeOrderBuddy) {
    return checkout().input.dispatchType !== dispatchType && cart().hasCartProducts
}

async function handleDispatchTypeChange (dispatchType: DispatchTypeOrderBuddy) {
    const route = useRoute()
    if (!isCheckoutPath(route.path) && !isAccountPath(route.path)) {
        await navigateTo(getDispatchTypeUrl(dispatchType))
    } else {
        await checkout().setDispatchType(dispatchType, true)
    }
}

export async function showDispatchTypeModal (dispatchType: DispatchTypeOrderBuddy, closeCallback?: () => Promise<void>, resetCallback?: () => Promise<void>) {
    if (!dispatchModalIsOpen) {
        dispatchModalIsOpen = true
        const modalInstance = await messagesModal({
            default: useModalSlot({
                component: ModalContentResetCart
            }),
            bottom: useModalSlot({
                component: ModalContentResetCartBottom,
                attrs: {
                    closeModal: async () => {
                        await modalInstance.close()
                        if (closeCallback) {
                            await closeCallback()
                        }
                        dispatchModalIsOpen = false
                    },
                    resetCart: async () => {
                        cart().resetCart()
                        await modalInstance.close()
                        await handleDispatchTypeChange(dispatchType)
                        if (resetCallback) {
                            await resetCallback()
                        }
                        dispatchModalIsOpen = false
                    }
                }
            })
        }, async () => {
            if (closeCallback) {
                await closeCallback()
            }
            dispatchModalIsOpen = false
        })
    }
}

export async function navigateToDispatchType (dispatchType: DispatchTypeOrderBuddy, closeCallback?: () => Promise<void>, resetCallback?: () => Promise<void>) {
    if (shouldResetCart(dispatchType)) {
        await showDispatchTypeModal(dispatchType, closeCallback, resetCallback)
    } else {
        await handleDispatchTypeChange(dispatchType)
    }
}

export function getDispatchTypeUrl (dispatchType: DispatchTypeOrderBuddy) {
    const localePath = useLocalePath()
    if (dispatchType === DispatchTypeOrderBuddy.DELIVER) {
        return localePath('/shop')
    } else {
        return localePath('/shop/pickup')
    }
}
